import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הגעגוע בלי להיבהל",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק להילחם בגעגוע. אני פוגש אותו כמו שהוא.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מפסיק להילחם בגעגוע. אני פוגש אותו כמו שהוא.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת איטית.",
      "אני לא מנסה להעלים את הגעגוע. רק לראות אותו."
    ],
      [
      "נשימה אחת איטית.",
      "אני לא מנסה להעלים את הגעגוע. רק לראות אותו."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה הדבר שאני הכי מתגעגע אליו עכשיו?",
      "אני שואל את עצמי:\nאיך הגעגוע הזה מרגיש בגוף שלי?",
      "אני שואל את עצמי:\nמה אני מנסה להשיג דרך הגעגוע הזה?"
    ],
      [
      "אני שואל את עצמי:\nמה הדבר שאני הכי מתגעגע אליו עכשיו?",
      "אני שואל את עצמי:\nאיך הגעגוע הזה מרגיש בגוף שלי?",
      "אני שואל את עצמי:\nמה אני מנסה להשיג דרך הגעגוע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "געגוע הוא רגש. הוא לא סכנה."
    ],
      [
      "סגירה:",
      "געגוע הוא רגש. הוא לא סכנה."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "רגש מול פעולה",
    opening: localizedGenderNode(
      [
      "היום אני מבדיל בין מה שאני מרגיש לבין מה שאני עושה."
    ],
      [
      "היום אני מבדיל בין מה שאני מרגיש לבין מה שאני עושה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nאיזו פעולה הגעגוע דוחף אותי לעשות?",
      "אני שואל את עצמי:\nמה קורה לי כשאני עושה את הפעולה הזו?",
      "אני שואל את עצמי:\nמה אני יכול להרשות לעצמי להרגיש — בלי לפעול?"
    ],
      [
      "אני שואל את עצמי:\nאיזו פעולה הגעגוע דוחף אותי לעשות?",
      "אני שואל את עצמי:\nמה קורה לי כשאני עושה את הפעולה הזו?",
      "אני שואל את עצמי:\nמה אני יכול להרשות לעצמי להרגיש — בלי לפעול?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אני יכול להרגיש הכול — בלי להגיב להכול."
    ],
      [
      "סגירה:",
      "אני יכול להרגיש הכול — בלי להגיב להכול."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הלולאה",
    opening: localizedGenderNode(
      [
      "היום אני מזהה לולאה במקום להיבלע בה."
    ],
      [
      "היום אני מזהה לולאה במקום להיבלע בה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה הטריגר שמדליק לי את הגעגוע?",
      "אני שואל את עצמי:\nאיך נראית הלולאה שלי מרגע הטריגר?",
      "אני שואל את עצמי:\nאיפה אני יכול לעצור את הלולאה ב־30 שניות?"
    ],
      [
      "אני שואל את עצמי:\nמה הטריגר שמדליק לי את הגעגוע?",
      "אני שואל את עצמי:\nאיך נראית הלולאה שלי מרגע הטריגר?",
      "אני שואל את עצמי:\nאיפה אני יכול לעצור את הלולאה ב־30 שניות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "געגוע הוא רגש — לא פקודה."
    ],
      [
      "סגירה:",
      "געגוע הוא רגש — לא פקודה."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מה באמת חסר לי",
    opening: localizedGenderNode(
      [
      "היום אני מחפש צורך, לא אדם."
    ],
      [
      "היום אני מחפש צורך, לא אדם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה חסר לי באמת ברגעי הגעגוע?",
      "אני שואל את עצמי:\nמתי הרגשתי את החוסר הזה גם לפני הקשר?",
      "אני שואל את עצמי:\nאיך אני יכול לפגוש את הצורך הזה היום, בקטן?"
    ],
      [
      "אני שואל את עצמי:\nמה חסר לי באמת ברגעי הגעגוע?",
      "אני שואל את עצמי:\nמתי הרגשתי את החוסר הזה גם לפני הקשר?",
      "אני שואל את עצמי:\nאיך אני יכול לפגוש את הצורך הזה היום, בקטן?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "לפעמים אני מתגעגע לצורך — לא לאדם."
    ],
      [
      "סגירה:",
      "לפעמים אני מתגעגע לצורך — לא לאדם."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "שליטה ואי־שליטה",
    opening: localizedGenderNode(
      [
      "היום אני משחרר שליטה במה שלא בידיים שלי."
    ],
      [
      "היום אני משחרר שליטה במה שלא בידיים שלי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nעל מה אני מנסה לשלוט דרך הגעגוע?",
      "אני שואל את עצמי:\nמה באמת לא בשליטתי?",
      "אני שואל את עצמי:\nאיפה כן יש לי בחירה קטנה היום?"
    ],
      [
      "אני שואל את עצמי:\nעל מה אני מנסה לשלוט דרך הגעגוע?",
      "אני שואל את עצמי:\nמה באמת לא בשליטתי?",
      "אני שואל את עצמי:\nאיפה כן יש לי בחירה קטנה היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "שליטה חוזרת דרך בחירה קטנה."
    ],
      [
      "סגירה:",
      "שליטה חוזרת דרך בחירה קטנה."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "געגוע מול אהבה",
    opening: localizedGenderNode(
      [
      "היום אני עושה הבחנה עדינה."
    ],
      [
      "היום אני עושה הבחנה עדינה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה בגעגוע שלי הוא אהבה — ומה הוא פחד מלהיות לבד?",
      "אני שואל את עצמי:\nמה הייתי רוצה לתת לעצמי במקום להיאחז?",
      "אני שואל את עצמי:\nמה עוזר לי להרגיש יציב בלי לאבד את עצמי?"
    ],
      [
      "אני שואל את עצמי:\nמה בגעגוע שלי הוא אהבה — ומה הוא פחד מלהיות לבד?",
      "אני שואל את עצמי:\nמה הייתי רוצה לתת לעצמי במקום להיאחז?",
      "אני שואל את עצמי:\nמה עוזר לי להרגיש יציב בלי לאבד את עצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אהבה מרחיבה. פחד מצמצם."
    ],
      [
      "סגירה:",
      "אהבה מרחיבה. פחד מצמצם."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הגוף בתוך הגעגוע",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב לגוף."
    ],
      [
      "היום אני מקשיב לגוף."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nאיפה הגוף שלי מחזיק את הגעגוע?",
      "אני שואל את עצמי:\nמה הגוף מבקש עכשיו?",
      "אני שואל את עצמי:\nאיזה רגש עדין מלווה את מה שהגוף מבקש?"
    ],
      [
      "אני שואל את עצמי:\nאיפה הגוף שלי מחזיק את הגעגוע?",
      "אני שואל את עצמי:\nמה הגוף מבקש עכשיו?",
      "אני שואל את עצמי:\nאיזה רגש עדין מלווה את מה שהגוף מבקש?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "כשאני מקשיב לגוף — המחשבות נרגעות."
    ],
      [
      "סגירה:",
      "כשאני מקשיב לגוף — המחשבות נרגעות."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול רך",
    opening: localizedGenderNode(
      [
      "היום אני שם גבול כדי להגן עליי."
    ],
      [
      "היום אני שם גבול כדי להגן עליי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nאיזו פעולה מגבירה את הגעגוע?",
      "אני שואל את עצמי:\nאיזה גבול קטן אני מוכן/ה לשים היום?",
      "אני שואל את עצמי:\nמה אני זוכה ממנו כשאני שומר/ת על הגבול?"
    ],
      [
      "אני שואל את עצמי:\nאיזו פעולה מגבירה את הגעגוע?",
      "אני שואל את עצמי:\nאיזה גבול קטן אני מוכן/ה לשים היום?",
      "אני שואל את עצמי:\nמה אני זוכה ממנו כשאני שומר/ת על הגבול?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "גבול הוא אקט של חמלה."
    ],
      [
      "סגירה:",
      "גבול הוא אקט של חמלה."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "הערך שלי",
    opening: localizedGenderNode(
      [
      "היום אני מחזיר ערך לעצמי."
    ],
      [
      "היום אני מחזיר ערך לעצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה הגעגוע גורם לי להאמין על הערך שלי?",
      "אני שואל את עצמי:\nמה אמת אחת שאני בוחר להחזיק במקום זה?",
      "אני שואל את עצמי:\nאיזה רגעים קטנים מזכירים לי את הערך שלי?"
    ],
      [
      "אני שואל את עצמי:\nמה הגעגוע גורם לי להאמין על הערך שלי?",
      "אני שואל את עצמי:\nמה אמת אחת שאני בוחר להחזיק במקום זה?",
      "אני שואל את עצמי:\nאיזה רגעים קטנים מזכירים לי את הערך שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "הערך שלי לא תלוי במישהו אחר."
    ],
      [
      "סגירה:",
      "הערך שלי לא תלוי במישהו אחר."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לילה ולופים",
    opening: localizedGenderNode(
      [
      "היום אני מכין סיום לפרק."
    ],
      [
      "היום אני מכין סיום לפרק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nאיזה מחשבה חוזרת בלילה?",
      "אני שואל את עצמי:\nאיזה משפט סגירה אני אומר לעצמי לפני שינה?",
      "אני שואל את עצמי:\nמה עוזר לי לשחרר את הלופ הלילי אפילו קצת?"
    ],
      [
      "אני שואל את עצמי:\nאיזה מחשבה חוזרת בלילה?",
      "אני שואל את עצמי:\nאיזה משפט סגירה אני אומר לעצמי לפני שינה?",
      "אני שואל את עצמי:\nמה עוזר לי לשחרר את הלופ הלילי אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "הלילה אני לא פותר. אני נח."
    ],
      [
      "סגירה:",
      "הלילה אני לא פותר. אני נח."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "הרגל חדש",
    opening: localizedGenderNode(
      [
      "היום אני מחליף תגובה."
    ],
      [
      "היום אני מחליף תגובה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה אני עושה אוטומטית כשעולה געגוע?",
      "אני שואל את עצמי:\nמה הרגל חלופי אחד קטן?",
      "אני שואל את עצמי:\nמה כבר עבד לי פעם כשהרגש התחזק?"
    ],
      [
      "אני שואל את עצמי:\nמה אני עושה אוטומטית כשעולה געגוע?",
      "אני שואל את עצמי:\nמה הרגל חלופי אחד קטן?",
      "אני שואל את עצמי:\nמה כבר עבד לי פעם כשהרגש התחזק?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "הרגל קטן משנה כיוון."
    ],
      [
      "סגירה:",
      "הרגל קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "חמלה",
    opening: localizedGenderNode(
      [
      "היום אני מדבר אליי בעדינות."
    ],
      [
      "היום אני מדבר אליי בעדינות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nאיך הייתי מדבר לחבר שמתגעגע כך?",
      "אני שואל את עצמי:\nאיזה משפט אני מוכן להגיד גם לעצמי?",
      "אני שואל את עצמי:\nאיך זה מרגיש בגוף כשאני אומר את זה לעצמי?"
    ],
      [
      "אני שואל את עצמי:\nאיך הייתי מדברת לחברה שמתגעגעת כך?",
      "אני שואל את עצמי:\nאיזה משפט אני מוכנה להגיד גם לעצמי?",
      "אני שואל את עצמי:\nאיך זה מרגיש בגוף כשאני אומרת את זה לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "חמלה מרגיעה לולאות."
    ],
      [
      "סגירה:",
      "חמלה מרגיעה לולאות."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "עתיד עדין",
    opening: localizedGenderNode(
      [
      "היום אני מביט קדימה בלי למהר."
    ],
      [
      "היום אני מביט קדימה בלי למהר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nאיך הייתי רוצה להרגיש בעוד חודש?",
      "אני שואל את עצמי:\nאיזה צעד קטן מקרב אותי לשם?",
      "אני שואל את עצמי:\nמה מפחיד קצת בעתיד — ומה אני אומר לעצמי על זה?"
    ],
      [
      "אני שואל את עצמי:\nאיך הייתי רוצה להרגיש בעוד חודש?",
      "אני שואל את עצמי:\nאיזה צעד קטן מקרב אותי לשם?",
      "אני שואל את עצמי:\nמה מפחיד קצת בעתיד — ומה אני אומרת לעצמי על זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "עתיד נבנה לאט."
    ],
      [
      "סגירה:",
      "עתיד נבנה לאט."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסכם בלי להילחם."
    ],
      [
      "היום אני מסכם בלי להילחם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "שאיפה איטית… נשיפה איטית…",
      "עוד אחת.",
      "אני מרגיש את הגוף שלי כאן, עכשיו.",
      "אני לא רוצה לפתור כלום כרגע — רק להיות."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה השתנה בי במסע הזה?",
      "אני שואל את עצמי:\nמה “משפט הדרך” שלי לימים קשים?",
      "אני שואל את עצמי:\nמה אני רוצה לזכור מהיום הזה?"
    ],
      [
      "אני שואל את עצמי:\nמה השתנה בי במסע הזה?",
      "אני שואל את עצמי:\nמה “משפט הדרך” שלי לימים קשים?",
      "אני שואל את עצמי:\nמה אני רוצה לזכור מהיום הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אני ממשיך ללכת — גם עם געגוע, וגם עם עצמי."
    ],
      [
      "סגירה:",
      "אני ממשיך ללכת — גם עם געגוע, וגם עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "טקס סיום: אני קורא את משפט הדרך פעם אחת, בקול או בלב.",
      "טקס סיום: אני קורא את משפט הדרך פעם אחת, בקול או בלב."
    ),
  },
].map(buildNormalizedDay);

export const obsessiveLongingBlueprintHe = buildNormalizedPilotBlueprint({
  id: "obsessive_longing_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "obsessive_longing",
  category: "general",
  journeyName: {
    he: "",
    en: "Obsessive longing that won’t let go",
    es: "",
  },
  days,
});

export default obsessiveLongingBlueprintHe;
